import { useState } from 'react';

import { MedicalImageInterface } from '@/shared/config';
import { useAppDispatch } from '@/shared/hooks';

import { reportsModel, useCheckReportSignature } from '@/entities/reports';

export const useAddAndRemoveMedicalImage = () => {
  const dispatch = useAppDispatch();

  const [isRemovingAllSlices, setIsRemovingAllSlices] = useState(false);

  const { checkReportSignature } = useCheckReportSignature();

  const addMedicalImageToSelected = (assetID: string, toothID: string) => {
    checkReportSignature({
      toothID,
      onSignatureChecked: async () => {
        await dispatch(
          reportsModel.thunks.addToothDisplaySlice({
            AssetID: assetID,
            ToothID: toothID,
          }),
        );
      },
    });
  };

  const removeMedicalImageFromSelected = async (
    assetID: string,
    toothID: string,
  ) => {
    checkReportSignature({
      toothID,
      onSignatureChecked: async () => {
        await dispatch(
          reportsModel.thunks.removeToothDisplaySlice({
            AssetID: assetID,
            ToothID: toothID,
          }),
        );
      },
    });
  };

  const toggleMedicalImageSelection = ({
    toothID,
    medicalImage,
    selectedMedicalImages,
  }: {
    toothID: string;
    medicalImage: MedicalImageInterface;
    selectedMedicalImages: MedicalImageInterface[];
  }) => {
    const isImageSelected = selectedMedicalImages.some(
      (item) => item.src === medicalImage.src,
    );

    if (isImageSelected) {
      removeMedicalImageFromSelected(medicalImage.assetID, toothID);
    } else {
      addMedicalImageToSelected(medicalImage.assetID, toothID);
    }
  };

  const removeAllMedicalImagesFromSelected = (toothID: string) => {
    checkReportSignature({
      toothID,
      onSignatureChecked: async () => {
        setIsRemovingAllSlices(true);

        try {
          await dispatch(
            reportsModel.thunks.removeAllToothDisplaySlices({
              ToothID: toothID,
            }),
          );
        } finally {
          setIsRemovingAllSlices(false);
        }
      },
    });
  };

  return {
    addMedicalImageToSelected,
    removeMedicalImageFromSelected,
    removeAllMedicalImagesFromSelected,
    toggleMedicalImageSelection,
    isRemovingAllSlices,
  };
};
